import type { FC } from 'react';
import { HStack } from '@chakra-ui/react';

import SunshineIconButton from 'components/_core/IconButton';
import SunshineCard, { SunshineCardProps } from 'components/_core/SunshineCard';

import locales from './locales';

type SupportingDocumentPreviewProps = SunshineCardProps & {
  href: string;
};

const SupportingDocumentPreview: FC<SupportingDocumentPreviewProps> = ({
  href,
  ...props
}) => {
  return (
    <SunshineCard alignItems="center" {...props}>
      <SunshineCard.Content>
        <SunshineCard.Title>{locales.supportingDocument}</SunshineCard.Title>
      </SunshineCard.Content>
      <SunshineCard.Slot name="action">
        <HStack spacing="space-16">
          <SunshineIconButton
            aria-label={locales.downloadSupportingDocument}
            as="a"
            download
            href={href}
            icon="download"
            rel="noopener noreferrer"
            target="_blank"
            variant="secondary"
          />
          <SunshineIconButton
            aria-label={locales.seeSupportingDocument}
            as="a"
            href={href}
            icon="eye-open"
            rel="noopener noreferrer"
            target="_blank"
            variant="secondary"
          />
        </HStack>
      </SunshineCard.Slot>
    </SunshineCard>
  );
};

export default SupportingDocumentPreview;
